{
  "login.instructions_title": "Authorize the CLI to access your Wix account:",
  "login.instructions_details": "1. Copy this code to the clipboard: <0>{code}</0>\n2. Press <1/> to <2>log in</2> and then paste the code",
  "login.legacy_auth_notice": "We implemented a new and more secure login method. You'll need to re-login to continue using the CLI.",
  "login.error_opening_browser": "Failed to open browser, please try opening <0/> manually."
}
